import React from 'react';
import { GlobalOutlined, UserOutlined } from '@ant-design/icons';
import { Flex, Space, Tag, Typography } from 'antd';
import styles from './ApiKeyName.module.scss';
import {
  API_KEY_ABOUT_TO_EXPIRE_LABEL,
  API_KEY_TYPE_LABELS,
  ApiKeyType,
} from '../constants/apiKeys';
import { IApiKey } from '../types/apiKeys';
import { willExpireSoon } from '../utils/apiKeys';

interface Props {
  apiKey: IApiKey;
}

const { Text } = Typography;

const ApiKeyName: React.FC<Props> = ({ apiKey }) => {
  const { name, personal, expires, expires_at: expiresAt } = apiKey;
  const aboutToExpire = expires && !!expiresAt && willExpireSoon(expiresAt);

  const description = personal
    ? API_KEY_TYPE_LABELS[ApiKeyType.Personal]
    : API_KEY_TYPE_LABELS[ApiKeyType.Service];

  return (
    <Flex align="center" className={styles.names} gap="middle" justify="left">
      {personal ? <UserOutlined /> : <GlobalOutlined />}
      <Space.Compact direction="vertical">
        <Text strong>{name}</Text>
        <Space>
          <Text type="secondary">{description}</Text>
          {aboutToExpire && (
            <Tag bordered={false} color="warning">
              {API_KEY_ABOUT_TO_EXPIRE_LABEL}
            </Tag>
          )}
        </Space>
      </Space.Compact>
    </Flex>
  );
};

export default ApiKeyName;
